import i18n from '../../utils/i18n';

export const DESIGN_SPEC_ATTRIBUTES = [
	{
		label: i18n.t('components.design.designSpecifications.constants.labels.datasheet'),
		value: 'datasheetUrl',
		preUnit: '',
		unit: ''
	},
	{
		label: i18n.t('components.design.designSpecifications.constants.labels.partNumber'),
		value: 'partNumber',
		preUnit: '',
		unit: ''
	},
	{
		label: i18n.t('components.design.designSpecifications.constants.labels.efficiency'),
		value: 'efficiency',
		preUnit: '',
		unit: '\u0020%'
	},
	{
		label: i18n.t('components.design.designSpecifications.constants.labels.bomCost'),
		value: 'designPriceFormatted',
		preUnit: '$',
		unit: ''
	},
	{
		label: i18n.t('components.design.designSpecifications.constants.labels.bomCount'),
		value: 'bomCount',
		preUnit: '',
		unit: ''
	},
	{
		label: i18n.t('components.design.designSpecifications.constants.labels.footprint'),
		value: 'designFootprint',
		preUnit: '',
		unit: '\u0020mm\u00b2'
	},
	{
		label: i18n.t('components.design.designSpecifications.constants.labels.topology'),
		value: 'topology',
		preUnit: '',
		unit: ''
	},
	{
		label: i18n.t('components.design.designSpecifications.constants.labels.frequency'),
		value: 'switchingFrequency',
		preUnit: '',
		unit: '\u0020kHz'
	},
	{
		label: i18n.t('components.design.designSpecifications.constants.labels.qualification'),
		value: 'autoQualified',
		preUnit: '',
		unit: ''
	}
];
